var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA2ComponentsList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.57 13L7 27.22V62h62V13H20.57zM65 58H11V29h11V17h43v41zM41 38H27v-4h25v4H41zm-3 8H27v-4h11v4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A2_Components_List.417e5934.svg";
export { SvgA2ComponentsList as ReactComponent };